import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddDeviceSensor from "./modal-add-device-sensor";
import EditDeviceSensor from "./modal-edit-device-sensor";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const DeviceSensor = () => {
  const [dataDeviceSensor, setDataDeviceSensor] = useState([]);
  const [dataDeviceSensorFilter, setDataDeviceSensorFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [uploadForm] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleCancel = () => {
    onShowImport(false);
  };

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const [showImport, setShowImport] = useState(false);
  const onShowImport = (val) => {
    setShowImport(val);
  };

  const getDeviceSensor = async () => {
    state.LOADING = true;

    await API.Get("rfid")
      .then((result) => {
        setDataDeviceSensor(result?.data);
        setDataDeviceSensorFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Device Sensor Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getDeviceSensor();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.number}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.number}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`rfid/${data.id}`)
          .then(() => {
            message.success("Device sensor has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete device sensor");
            console.error(err);
          })
          .finally(() => {
            getDeviceSensor();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "No. RFID",
      dataIndex: "number",
      key: "number",
      sorter: (a, b) => {
        if (a.number === null || a.number === "-") return 1;
        if (b.number === null || b.number === "-") return -1;
        return a.number.localeCompare(b.number);
      },
      render: (number) => (number ? number : "-"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => {
        if (a.created_at === null || a.created_at === "-") return 1;
        if (b.created_at === null || b.created_at === "-") return -1;
        return a.created_at.localeCompare(b.created_at);
      },
      render: (created_at) =>
        created_at ? dayjs(created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      sorter: (a, b) => {
        if (a.updated_at === null || a.updated_at === "-") return 1;
        if (b.updated_at === null || b.updated_at === "-") return -1;
        return a.updated_at.localeCompare(b.updated_at);
      },
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataDeviceSensor.filter((sensor) =>
      sensor.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataDeviceSensorFilter(data);
  };

  const onClear = async (val) => {
    getDeviceSensor();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const normFile = (e) => {
    return e?.target?.files[0]; // Extract the selected file
  };

  const onFinish = async (values) => {
    setConfirmLoading(true);
    const { file } = values;

    let dataForm = {
      file,
    };

    const formData = new FormData();

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }

    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    await API.Post("rfid/upload", formData)
      .then(() => {
        setConfirmLoading(false);
        message.success("Import RFID has been success");
        getDeviceSensor();
        uploadForm.resetFields();
        onShowImport(false);
      })
      .catch((err) => {
        console.log(err);
        setConfirmLoading(false);
        message.info(`${err?.response?.data?.error}`);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <FilterMenu
        onShowAdd={onShowAdd}
        onSearch={onSearch}
        onClear={onClear}
        onShowImport={onShowImport}
      />

      {/* DeviceSensor Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataDeviceSensorFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add DeviceSensor */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddDeviceSensor
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetDeviceSensor={getDeviceSensor}
        />
      </div>

      {/* Modal Edit DeviceSensor */}
      <EditDeviceSensor
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetDeviceSensor={getDeviceSensor}
        selectedData={selectedData}
      />

      <Modal
        title="Pilih File Format .csv"
        okText="Submit"
        cancelText="Batal"
        open={showImport}
        onOk={uploadForm.submit}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okType={"primary"}
      >
        <Form
          form={uploadForm}
          name="Upload Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Pilih File"
            name="file"
            valuePropName="file"
            getValueFromEvent={normFile}
            rules={[
              {
                required: true,
                message: "Please input your Pilih File!",
              },
            ]}
          >
            <Input placeholder="Pilih File" type="file" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeviceSensor;
